import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import { query as i } from '../../../../node_modules/@lit/reactive-element/decorators/query.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../buttons/generic-button2.0/index.js';
import '../../molecules/video-player-plus/index.js';
import '../../molecules/video-player/index.js';
import { VideoTypes } from '../../molecules/video-player-plus/types.js';
import css_248z from './modal-container-updated.scss.js';
import { hasYoutubeConsent, whenYoutubeConsent } from '../../molecules/video-player/youtube-bootstrap.js';

class ModalContainerUpdated extends s {
    constructor() {
        super(...arguments);
        this.popupId = '';
        this.showOnPageLoad = false;
        this.rtl = false;
        this.title = '';
        this.closeButtonText = 'Close modal';
        this.hasVideo = false;
        this.videoId = '';
        this.videoType = VideoTypes.YOUTUBE;
        this.closedCaptions = '';
        this.closedCaptionsLang = 'en';
        this.audioDescription = '';
        this.audioDescriptionLang = 'en';
        this.isExternalLink = false;
        this.isVisible = false;
        this.hasFooter = false;
        this.titleId = `cvtm-title-${crypto.randomUUID()}`;
    }
    connectedCallback() {
        super.connectedCallback();
        this.focusTrap = document.activeElement;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.isVisible) {
            document.documentElement.style.overflow = '';
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('hasFooter')) {
            this.requestUpdate();
        }
    }
    firstUpdated() {
        if (this.showOnPageLoad) {
            this.showModal();
        }
        this._syncFooterPresence();
    }
    showModal() {
        var _a, _b, _c;
        if (!this.dialog)
            return;
        this.focusTrap = document.activeElement;
        this.isVisible = true;
        if (!this.dialog.open) {
            this.dialog.showModal();
        }
        // DCCC-8359: the YouTube player inside the modal is initialised only when
        // the modal is shown. Consented visitors get the API player (cued, as
        // always). Unconsented visitors get a cookie-free nocookie iframe (cued,
        // no autoplay); the API — whose bootstrap sets .youtube.com cookies —
        // attaches only if consent is granted later.
        if (this.hasVideo && this.videoId) {
            const videoPlayer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('video-player-plus');
            if (videoPlayer) {
                if (hasYoutubeConsent()) {
                    (_b = videoPlayer.initPlayer) === null || _b === void 0 ? void 0 : _b.call(videoPlayer);
                }
                else {
                    (_c = videoPlayer.mountCookieFreeIframe) === null || _c === void 0 ? void 0 : _c.call(videoPlayer, false);
                    whenYoutubeConsent(() => { var _a; return (_a = videoPlayer.initPlayer) === null || _a === void 0 ? void 0 : _a.call(videoPlayer); });
                }
            }
        }
        document.documentElement.style.overflow = 'hidden';
        this.dispatchEvent(new CustomEvent('modal-opened', {
            bubbles: true,
            composed: true,
            detail: { popupId: this.popupId },
        }));
    }
    hideModal() {
        if (!this.dialog)
            return;
        this.isVisible = false;
        if (this.dialog.open) {
            this.dialog.close();
        }
        document.documentElement.style.overflow = '';
        this.dispatchEvent(new CustomEvent('modal-closed', {
            bubbles: true,
            composed: true,
            detail: { popupId: this.popupId },
        }));
        if (this.focusTrap && typeof this.focusTrap.focus === 'function') {
            setTimeout(() => { var _a; return (_a = this.focusTrap) === null || _a === void 0 ? void 0 : _a.focus(); }, 0);
        }
    }
    _handleDialogClick(e) {
        if (e.target === this.dialog) {
            this.hideModal();
        }
    }
    _handleCancel(e) {
        e.preventDefault();
        this.hideModal();
    }
    _handleKeydown(e) {
        if (e.key === 'Escape') {
            e.preventDefault();
            this.hideModal();
        }
    }
    _handleFooterSlotChange() {
        this._syncFooterPresence();
        if (!this.isExternalLink) {
            this._applyFooterSpacing();
        }
        else {
            this._ensureButtonsCanCloseModal();
        }
    }
    _ensureButtonsCanCloseModal() {
        const { footerSlot } = this;
        if (!footerSlot)
            return;
        requestAnimationFrame(() => {
            const assignedElements = footerSlot.assignedElements({
                flatten: true,
            });
            const CLICK_EVENT = 'click';
            const HANDLER_PROP = '_modalCloseHandlerAdded';
            const CLOSE_MODAL_PROP = 'closeModal';
            const addCloseHandler = (button) => {
                const btn = button;
                if ((btn === null || btn === void 0 ? void 0 : btn[CLOSE_MODAL_PROP]) && !btn[HANDLER_PROP]) {
                    btn.addEventListener(CLICK_EVENT, () => {
                        this.hideModal();
                    });
                    btn[HANDLER_PROP] = true;
                }
            };
            assignedElements.forEach(el => {
                if (ModalContainerUpdated.BUTTON_TAGS.includes(el.tagName.toLowerCase())) {
                    addCloseHandler(el);
                }
                if (el instanceof HTMLElement) {
                    const nestedButtons = el.querySelectorAll(ModalContainerUpdated.BUTTON_SELECTOR);
                    nestedButtons.forEach(btn => addCloseHandler(btn));
                }
            });
        });
    }
    _syncFooterPresence() {
        var _a, _b;
        const elements = (_b = (_a = this.footerSlot) === null || _a === void 0 ? void 0 : _a.assignedElements({ flatten: true })) !== null && _b !== void 0 ? _b : [];
        this.hasFooter = elements.length > 0;
    }
    _applyFooterSpacing() {
        if (!this.footerSlot)
            return;
        const assignedElements = this.footerSlot.assignedElements({
            flatten: true,
        });
        const buttons = [];
        assignedElements.forEach(el => {
            if (ModalContainerUpdated.BUTTON_TAGS.includes(el.tagName.toLowerCase())) {
                buttons.push(el);
            }
            else if (el instanceof HTMLElement) {
                const nestedButtons = el.querySelectorAll(ModalContainerUpdated.BUTTON_SELECTOR);
                nestedButtons.forEach(btn => buttons.push(btn));
            }
        });
        buttons.forEach(btn => btn.classList.remove('cvtm-footer-spaced'));
        buttons.forEach((btn, index) => {
            if (index > 0) {
                btn.classList.add('cvtm-footer-spaced');
            }
        });
    }
    _renderFooterTemplate() {
        const footerSlot = $ `<slot id="footerSlot" name="footer" @slotchange="${this._handleFooterSlotChange}"></slot>`;
        if (this.hasFooter) {
            return $ `<div class="cvtm__footer">${footerSlot}</div>`;
        }
        return footerSlot;
    }
    render() {
        const modalTitle = this.title.trim();
        const direction = this.rtl ? 'rtl' : 'ltr';
        const modalClass = this.hasVideo ? 'cvtm cvtm--with-video' : 'cvtm';
        const footerTemplate = this._renderFooterTemplate();
        const closeButton = $ `<generic-button-updated class="cvtm__close" appearance="icon-circle" color="purple" type="tertiary" .label="${''}" icon="close" .ariaList="${{
            label: this.closeButtonText,
        }}" @click="${this.hideModal}"></generic-button-updated>`;
        const videoTemplate = this.hasVideo && this.videoId
            ? $ `<div class="cvtm__video"><video-player-plus .type="${this.videoType}" .videoId="${this.videoId}" .closedCaptions="${this.closedCaptions}" .closedCaptionsLang="${this.closedCaptionsLang}" .audioDescription="${this.audioDescription}" .audioDescriptionLang="${this.audioDescriptionLang}" ?autoinit="${true}"></video-player-plus></div>`
            : '';
        const titleTemplate = modalTitle
            ? $ `<h2 id="${this.titleId}" class="cvtm__title">${modalTitle}</h2>`
            : '';
        const headerTemplate = $ `<div class="cvtm__header">${titleTemplate} ${closeButton}</div>`;
        const bodyContent = $ `<slot name="content"></slot>`;
        return $ `<dialog class="${modalClass}" dir="${direction}" aria-modal="true" aria-labelledby="${modalTitle ? this.titleId : ''}" @click="${this._handleDialogClick}" @keydown="${this._handleKeydown}" @cancel="${this._handleCancel}">${headerTemplate}<div class="cvtm__body">${bodyContent}</div>${videoTemplate} ${footerTemplate}</dialog>`;
    }
}
ModalContainerUpdated.styles = css_248z;
ModalContainerUpdated.BUTTON_TAGS = ['generic-button-updated', 'generic-button'];
ModalContainerUpdated.BUTTON_SELECTOR = ModalContainerUpdated.BUTTON_TAGS.join(', ');
__decorate([
    e({ type: String, reflect: true })
], ModalContainerUpdated.prototype, "popupId", void 0);
__decorate([
    e({ type: Boolean, attribute: 'show-on-load' })
], ModalContainerUpdated.prototype, "showOnPageLoad", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], ModalContainerUpdated.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], ModalContainerUpdated.prototype, "title", void 0);
__decorate([
    e({ type: String, attribute: 'close-button-text' })
], ModalContainerUpdated.prototype, "closeButtonText", void 0);
__decorate([
    e({ type: Boolean, attribute: 'has-video' })
], ModalContainerUpdated.prototype, "hasVideo", void 0);
__decorate([
    e({ type: String, attribute: 'video-id' })
], ModalContainerUpdated.prototype, "videoId", void 0);
__decorate([
    e({ type: String, attribute: 'video-type' })
], ModalContainerUpdated.prototype, "videoType", void 0);
__decorate([
    e({ type: String, attribute: 'closed-captions' })
], ModalContainerUpdated.prototype, "closedCaptions", void 0);
__decorate([
    e({ type: String, attribute: 'closed-captions-lang' })
], ModalContainerUpdated.prototype, "closedCaptionsLang", void 0);
__decorate([
    e({ type: String, attribute: 'audio-description' })
], ModalContainerUpdated.prototype, "audioDescription", void 0);
__decorate([
    e({ type: String, attribute: 'audio-description-lang' })
], ModalContainerUpdated.prototype, "audioDescriptionLang", void 0);
__decorate([
    e({ type: Boolean, attribute: 'is-external-link' })
], ModalContainerUpdated.prototype, "isExternalLink", void 0);
__decorate([
    t()
], ModalContainerUpdated.prototype, "isVisible", void 0);
__decorate([
    t()
], ModalContainerUpdated.prototype, "hasFooter", void 0);
__decorate([
    i('dialog')
], ModalContainerUpdated.prototype, "dialog", void 0);
__decorate([
    i('#footerSlot')
], ModalContainerUpdated.prototype, "footerSlot", void 0);
customElements.define('cvt-modal-updated', ModalContainerUpdated);

export { ModalContainerUpdated };
